export default __webpack_public_path__ + "static/media/sfrxETH.aa1ba681.svg";